import { EPaymentPlan } from '@if/core/types'
import type { TermPlanOption } from '@src/components/WorksheetForm'

/**
 * A calculator quote has no credit decision behind it, so there is no real payment cap —
 * this is the sanity ceiling the merchant dashboard's calculator uses. Passing 0 would make
 * the terms service reject every term (`payment > MaxPmtAmount`).
 */
export const MAX_PAYMENT_AMOUNT = 5000

/**
 * The default (non-promotional) plan sentinel. Widened to `string` because plan ids are plain
 * strings once a merchant's own plans are in the list — the enum only names this one value.
 */
export const REGULAR_PLAN_ID: string = EPaymentPlan.RegularDailyInterests

export const pickDefaultTermPlanOption = (options: TermPlanOption[]): TermPlanOption | undefined => {
  const selectable = options.filter((option) => !option.disabled)
  const regular = selectable.filter((option) => option.paymentPlanId === REGULAR_PLAN_ID)
  if (regular.length > 0)
    return regular.reduce((longest, option) => (option.termMonths > longest.termMonths ? option : longest))
  return selectable[0]
}
